import { visitAll } from "@angular/compiler";

export class Field<T> {
    key: string;
    label: string;
    tooltip: string;
    value: T;
    data_type: string;
    display_type: string;
    header: string;
    order: number;
    required: boolean;
    read_only: boolean;
    sn_ID: string;
    condition: string;
    visible: boolean;
    rows: number;
    class: string;
    details: any;
    mask: string;
    sn_visible: string;
    max_length: number;
    checked: boolean;
    default_value: string;
    icon_class: string;
    row_class: string;
    child_controls: string[];

    constructor(options: {
        key?: string,
        label?: string,
        tooltip?: string,
        value?: T,
        data_type?: string,
        display_type?: string,
        header?: string,
        order?: number,
        required?: boolean,
        read_only?: boolean,
        sn_ID?: string,
        condition?: string,
        visible?: boolean,
        rows?: number,
        class?: string,
        details?: any,
        mask?: string,
        sn_visible?: string,
        max_length?: number,
        checked?: boolean,
        icon_class?: string,
        default_value?: string,
        row_class?: string,
        child_controls?: string[]
    } = { }) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.tooltip = options.tooltip || undefined;
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.display_type = options.display_type || '';
        this.data_type = options.data_type || '';
        this.header = options.header || '';
        this.icon_class = options.icon_class || '';
        this.read_only = !!options.read_only;
        this.sn_ID = options.sn_ID || '';
        this.condition = options.condition || '';
        this.visible = options.visible === undefined ? true : options.visible;
        this.rows = options.rows || 1;
        this.class = options.class || '';
        this.details = options.details || undefined;
        this.mask = options.mask || undefined;
        this.sn_visible = options.sn_visible || undefined;
        this.max_length = options.max_length || undefined;
        this.checked = !!options.checked;
        this.default_value = options.default_value;
        this.row_class = options.row_class;
        this.child_controls = options.child_controls || [];
    }

    isInput():boolean {
        switch (this.data_type) {
            case "": return false;
            default: return true;  
        }
    }

    isReadOnly():boolean {
        return this.read_only;
    }

    hasToolTip():boolean {
        return this.tooltip && this.tooltip.length > 0;
    }

    public static getFormValue(field, data) {
        switch (field.display_type) {
            case CheckboxField.control_type: return CheckboxField.getFormValue(field, data);
            case MultiSelectField.control_type: return MultiSelectField.getFormValue(field, data);
            case MultiSelectListField.control_type: return MultiSelectListField.getFormValue(field, data);
            default: return data[field.key] ? data[field.key] : null;
        }
    }
}

export class ReadOnlyField extends Field<string> {
    static readonly control_type = "RO";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class TextboxField extends Field<string> {
    static readonly control_type = "T";

    constructor(options: {} = {}) {
        super(options);
    }
}


export class UrlField extends Field<string> {
    static readonly control_type = "URL";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class TextAreaField extends Field<string> {
    static readonly control_type = "TA";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class IntegerField extends Field<string> {
    static readonly control_type = "I";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class NumberField extends Field<string> {
    static readonly control_type = "N";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class MultiSelectField extends Field<string> {
    static readonly control_type = "MS";

    constructor(options: {} = {}) {
        super(options);
    }

    public static getFormValue(field, data) { 
        var value = data[field.key];
        var ms_value = (value && value.length > 0) ? value.split(';') : [];
        var unique_values = [];
        ms_value.forEach(v => {
            if (unique_values.indexOf(v) < 0) unique_values.push(v);
        });
        return unique_values;
    }
}

export class MultiSelectListField extends Field<string> {
    static readonly control_type = "MSL";

    constructor(options: {} = {}) {
        super(options);
    }

    public static getFormValue(field, data) { 
        var value = data[field.key];
        var ms_value = (value && value.length > 0) ? value.split(';') : [];
        var unique_values = [];
        ms_value.forEach(v => {
            if (unique_values.indexOf(v) < 0) unique_values.push(v);
        });
        return unique_values;
    }
}

export class CheckboxField extends Field<string> {
    static readonly control_type = "C";

    constructor(options: {} = {}) {
        super(options);
    }

    public static getFormValue(field, data) { 
        return (field.checked) ? "Yes" : "";
    }
}

export class DropdownField extends Field<string> {
    static readonly control_type = "L";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class RadioListField extends Field<string> {
    static readonly control_type = "R";

    constructor(options: {} = {}) {
        super(options);
    }
}


export class DateField extends Field<string> {
    static readonly control_type = "D";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class DateTimeField extends Field<string> {
    static readonly control_type = "DT";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class FileField extends Field<string> {
    static readonly control_type = "FL";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class UserField extends Field<string> {
    static readonly control_type = "UR";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class DropdownPanelField extends Field<string> {
    static readonly control_type = "DDP";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class HeaderField extends Field<string> {
    static readonly control_type = "H";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class SeparatorField extends Field<string> {
    static readonly control_type = "S";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class Separator1Field extends Field<string> {
    static readonly control_type = "S1";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class ImageUrlField extends Field<string> {
    static readonly control_type = "IURL";

    constructor(options: {} = {}) {
        super(options);
    }
}

export class CustomInputField extends Field<string> {
    static readonly control_type = "CI";

    constructor(options: {} = {}) {
        super(options);
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/models/field.model.ts